import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectSandbox } from '../sandbox/sandboxSlice';
import { setDirectSignupEmailSubs } from './directSignupSlice';
import { Routes, SandboxRoutes } from '../../app/AppRouter';
import { SignupEmail } from '../../components/registration/SignupEmail/SignupEmail';
import { useHistory } from 'react-router';

export const DirectSignupEmail: React.FC = () => {
  const sandbox = useSelector(selectSandbox);
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <SignupEmail
      emailNext={(email: string, subs: boolean) =>
        dispatch(setDirectSignupEmailSubs({ email: email, newsletterOptin: subs }))
      }
      cancelClicked={() => history.push(sandbox ? SandboxRoutes.home : Routes.home)}
      sandbox={sandbox}
    />
  );
};
